import {
	ArrayMaxSize,
	ArrayNotEmpty,
	IsArray,
	IsInt,
	IsUUID,
	Max,
	Min,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

export class SubmitPredictionDto {
	@IsUUID()
	market_id: string;

	@IsUUID()
	lobby_id: string;

	@IsInt()
	@Min(1)
	@Max(99)
	probability: number;
}

// Wrapping class so class-validator recurses into each item of `predictions`
// on POST /v1/predictions/batch. Inline `{ predictions: SubmitPredictionDto[] }`
// only exists at compile time — the validator has no way to reach the array
// items at runtime, which is how NaN probabilities slipped through 2026-07-02.
export class SubmitPredictionsBatchDto {
	@IsArray()
	@ArrayNotEmpty()
	@ArrayMaxSize(50)
	@ValidateNested({ each: true })
	@Type(() => SubmitPredictionDto)
	predictions: SubmitPredictionDto[];
}

export class UpdatePredictionDto {
	@IsInt()
	@Min(1)
	@Max(99)
	probability: number;
}
